import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

interface PostLoginBody {
  email: string;
  password: string;
}

export const LabelApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getLabel: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
      }
    >({
      query: ({ search } = {}) => ({
        url: `${END_POINTS.getLabel}${
          search && search.trim() !== ""
            ? `?search=${encodeURIComponent(search)}`
            : ""
        }`,
        method: "GET",
      }),
    }),
    getLabelById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getLabel}/${id}/`,
        method: "GET",
      }),
    }),
    addLabel: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addLabel,
        method: "POST",
        body,
      }),
    }),
    updateLabel: builder.mutation<CommonResponseType, { body: any }>({
      query: ({ body }) => ({
        url: END_POINTS.addLabel,
        method: "POST",
        body,
      }),
    }),

    deleteLabel: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteLabel}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetLabelQuery,
  useAddLabelMutation,
  useUpdateLabelMutation,
  useDeleteLabelMutation,
  useLazyGetLabelByIdQuery,
} = LabelApi;
